import { RenderElementProps } from 'slate-react';

import { CustomElement } from '../types';

// Inline void pill for an @-mention. Matches the desk internal-note mention
// visual (MentionElement): orange pill.
const MentionComponent = ({ attributes, children, element }: RenderElementProps) => {
  const mention = (element as CustomElement).mention;
  return (
    <span
      {...attributes}
      contentEditable={false}
      className="my-px inline-block rounded-2xl bg-v2orange/15 px-2 pb-[3px] pt-0.5 font-semibold text-v2orange"
    >
      {children}@{mention?.label}
    </span>
  );
};

export default MentionComponent;
